import type { Translate } from 'next-translate';
import React from 'react';
import { Container } from '@/components/elements/Container';
import { LinkWithQuery } from '@/components/elements/LinkWithQuery';
import type { LandingMain } from '@/types';
import { BenefitVisual } from './BenefitVisual';
import styles from './MainBenefits.module.scss';

interface Props {
	data: LandingMain['benefits'];
	t: Translate;
	toolsHref: string;
	onCtaClick: () => void;
}

export const MainBenefits: React.FC<Props> = ({
	data,
	t,
	toolsHref,
	onCtaClick,
}) => (
	<section className={styles['benefits']}>
		<Container>
			<h2 className={styles['benefits__title']}>{t(data.title)}</h2>

			<ul className={styles['benefits__list']}>
				{data.list.map(item => (
					<li
						key={item.id}
						className={`${styles['card']} ${styles[`card_${item.id}`]}`}
					>
						<h3 className={styles['card__title']}>{t(item.title)}</h3>
						<p className={styles['card__text']}>{t(item.text)}</p>
						<BenefitVisual id={item.id} t={t} />
					</li>
				))}
			</ul>

			<LinkWithQuery
				href={toolsHref}
				className={styles['benefits__button']}
				onClick={onCtaClick}
			>
				{t(data.buttonText)}
			</LinkWithQuery>
		</Container>
	</section>
);
